import React from 'react';
import pt from 'prop-types';
import { MrInputSelect } from '@ion/components';
import { CMP_PRESET_OPTIONS } from './CMP_PRESETS';
import { CONSENT_CMP_PRESET } from 'app/components/analytics-builder/form-keys';

export default function CmpPresetSelect({ formState, setField, validateField, validateRequired, resetError }) {
  return (
    // Deliberately no default selection — which CMP a customer runs is a
    // compliance decision the user must make, not one the form guesses at.
    <MrInputSelect
      label="Consent Management Platform"
      onChange={setField}
      value={formState[CONSENT_CMP_PRESET]?.value ?? ''}
      name={CONSENT_CMP_PRESET}
      onBlur={validateField}
      onFocus={resetError}
      errorMsg={formState[CONSENT_CMP_PRESET]?.errorMsg}
      validators={[validateRequired()]}
      options={CMP_PRESET_OPTIONS}
      alphabetized={false}
      placeholder="Select your CMP…"
      required
      helperText="MetaRouter waits up to 3 seconds for consent, then uses the Consent Policy default if unresolved. Preference changes automatically trigger a refresh."
    />
  );
}

CmpPresetSelect.propTypes = {
  formState: pt.object.isRequired,
  setField: pt.func.isRequired,
  validateField: pt.func.isRequired,
  validateRequired: pt.func.isRequired,
  resetError: pt.func.isRequired,
};
